import { getHostAppName } from './getHostAppName';

/** Tracking properties that cannot be inferred from the `ListingCard`,
 * and thus must be provided separately. */

export function combineTrackingProps({
  componentType,
  listing,
  trackingProps
}) {
  var _listing$products$, _listing$products$2, _listing$recommendati, _listing$products$3, _trackingProps$result, _trackingProps$result2;
  return {
    // inferred from `ListingCard`
    companyName: listing.companyName,
    installed: (_listing$products$ = listing.products[0]) === null || _listing$products$ === void 0 ? void 0 : _listing$products$.installed,
    listingId: listing.listingId,
    portalInstallable: (_listing$products$2 = listing.products[0]) === null || _listing$products$2 === void 0 ? void 0 : _listing$products$2.portalInstallable,
    recommendationType: (_listing$recommendati = listing.recommendationSources) === null || _listing$recommendati === void 0 ? void 0 : _listing$recommendati.map(s => `${s.sourceName}__${s.version}`),
    slug: listing.slug,
    sourceId: listing.products.map(({
      sourceId,
      productType
    }) => `${String(productType)}__${sourceId}`),
    type: (_listing$products$3 = listing.products[0]) === null || _listing$products$3 === void 0 ? void 0 : _listing$products$3.productType,
    // provided by `TrackingProps`
    category: trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.collectionSlug,
    collectionId: trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.collectionId,
    pageNumber: trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.pageNumber,
    queryType: trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.queryType,
    resultCount: (_trackingProps$result = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.resultCount) !== null && _trackingProps$result !== void 0 ? _trackingProps$result : -1,
    resultIndex: (_trackingProps$result2 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.resultIndex) !== null && _trackingProps$result2 !== void 0 ? _trackingProps$result2 : -1,
    search: trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.search,
    section: trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.section,
    // other
    componentType,
    hostApp: getHostAppName(),
    resultType: 'LISTING'
  };
}